export const defaultColors = ['#454a68', '#aae1e0', '#cee7ed', '#d46d4e', '#a5a5a5', '#e2696c'];
